module.exports = __webpack_public_path__ + "static/jaime-42bd1c95389dfd711f8167fd28966e5d.svg";